import "core-js/modules/es.array.reduce.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectDestructuringEmpty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useReducer, useRef, useCallback, useEffect, useMemo, useDebugValue, useContext, isValidElement } from 'react';
import breakLines from 'break-styled-lines';

function isPlayedWindup(windup) {
  return windup.length === 2;
}

function memberIsWindup(member) {
  // If it's not an array it can't be a windup
  if (!Array.isArray(member)) {
    return false;
  } // If it has less or more than three members it's not a windup


  if (member.length !== 3) {
    return false;
  } // If its first or second members are not arrays it's not a windup


  if (!Array.isArray(member[0]) || !Array.isArray(member[1])) {
    return false;
  } // Past here we just have to hope ElementType isn't a windup.


  return true;
}

function windupFromString(str, metadata) {
  return [[], str.split(""), metadata];
}

function newWindup(arg, metadata) {
  return [[], arg, metadata];
}

function isUnplayed(windup) {
  var _windup = _slicedToArray(windup, 2),
      played = _windup[0],
      remaining = _windup[1];

  if (played.length > 0) {
    return false;
  }

  return remaining.reduce(function (unplayed, member) {
    if (memberIsWindup(member)) if (memberIsWindup(windup) && unplayed) {
      return isUnplayed(member);
    }
    return unplayed;
  }, true);
}

function isFinished(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      _played = _ref2[0],
      remaining = _ref2[1];

  return remaining.length === 0;
}

function fastForward(windup) {
  var forwardedWindup = next(windup);

  if (isFinished(forwardedWindup)) {
    return forwardedWindup;
  }

  return fastForward(forwardedWindup);
}

function rewind(windup) {
  if (isUnplayed(windup)) {
    return windup;
  }

  var _windup2 = _slicedToArray(windup, 3),
      played = _windup2[0],
      remaining = _windup2[1],
      metadata = _windup2[2];

  var mapRewind = function mapRewind(member) {
    if (memberIsWindup(member)) {
      return rewind(member);
    }

    return member;
  };

  return [[], [].concat(_toConsumableArray(played.map(mapRewind)), _toConsumableArray(remaining.map(mapRewind))), metadata];
}

function lastPlayedMember(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      played = _ref4[0],
      remaining = _ref4[1];

  var playedFromRemaining = remaining.reduce(function (playedEl, member) {
    if (memberIsWindup(member)) {
      if (!isUnplayed(member)) {
        return lastPlayedElement(member);
      }
    }

    return playedEl;
  }, undefined);

  if (playedFromRemaining) {
    return playedFromRemaining;
  }

  var last = played[played.length - 1];
  return last;
}

function lastPlayedElement(windup) {
  var lastPlayed = lastPlayedMember(windup);

  if (memberIsWindup(lastPlayed)) {
    return lastPlayedElement(lastPlayed);
  }

  return lastPlayed;
}

function playedElements(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      played = _ref6[0],
      remaining = _ref6[1];

  var playedTransformed = played.map(function (member) {
    if (memberIsWindup(member)) {
      var _member = _slicedToArray(member, 3),
          _played = _member[0],
          _remaining = _member[1],
          metadata = _member[2];

      return [playedElements(member), metadata];
    }

    return member;
  });

  var _remaining2 = _slicedToArray(remaining, 1),
      firstRemaning = _remaining2[0];

  if (memberIsWindup(firstRemaning) && !isUnplayed(firstRemaning)) {
    var _firstRemaning = _slicedToArray(firstRemaning, 3),
        _playedRemaining = _firstRemaning[0],
        _remaining = _firstRemaning[1],
        metadata = _firstRemaning[2];

    return [].concat(_toConsumableArray(playedTransformed), [[playedElements(firstRemaning), metadata]]);
  }

  return playedTransformed;
}

function nextElement(_ref7) {
  var _ref8 = _slicedToArray(_ref7, 2),
      _played = _ref8[0],
      remaining = _ref8[1];

  var _remaining3 = _slicedToArray(remaining, 1),
      nextVal = _remaining3[0];

  if (memberIsWindup(nextVal)) {
    return nextElement(nextVal);
  }

  return nextVal;
}

function next(windup) {
  // start
  // [[], [[[], ["h", "i"]], [[], ["n", "o"]]]]
  // next
  // [[], [[["h"], ["i"]], ["", ["n", "o"]]]]
  // next
  // [["h", "i"], [["n", "o"]]]
  // next
  // [["h", "i"] ["n", "o"]], []]
  if (isFinished(windup)) {
    return windup;
  }

  var _windup3 = _slicedToArray(windup, 3),
      played = _windup3[0],
      remaining = _windup3[1],
      metadata = _windup3[2];

  var _remaining4 = _toArray(remaining),
      firstRemaining = _remaining4[0],
      restRemaining = _remaining4.slice(1);

  if (memberIsWindup(firstRemaining)) {
    var nextFirstRemaining = next(firstRemaining);

    if (isFinished(nextFirstRemaining)) {
      return [[].concat(_toConsumableArray(played), [nextFirstRemaining]), restRemaining, metadata];
    }

    return [played, [nextFirstRemaining].concat(_toConsumableArray(restRemaining)), metadata];
  }

  return [[].concat(_toConsumableArray(played), [firstRemaining]), restRemaining, metadata];
}

function defaultGetPace(lastChar, nextChar) {
  switch (lastChar) {
    case "—":
    case "…":
      return 200;

    case ".":
    case ",":
      return 150;

    case "?":
    case "!":
      if (nextChar !== "!" && nextChar !== "?") {
        return 150;
      }

    case "-":
    case " ":
    case "\n":
      return 0;

    default:
      return 20;
  }
}

var Pace = function Pace(_ref9) {
  var children = _ref9.children;
  return React.createElement(React.Fragment, null, children);
};

function isPaceElement(element) {
  return element.type === Pace;
}

function isMsProp(props) {
  if ("ms" in props) {
    return true;
  }

  return false;
}

function paceFromWindup(windup, parentPace) {
  if (isFinished(windup)) {
    return undefined;
  }

  var _windup4 = _slicedToArray(windup, 3),
      remaining = _windup4[1],
      metadata = _windup4[2];

  var _remaining5 = _slicedToArray(remaining, 1),
      firstRemaining = _remaining5[0];

  if (firstRemaining && memberIsWindup(firstRemaining)) {
    return paceFromWindup(firstRemaining, metadata.pace || parentPace);
  }

  return metadata.pace || parentPace;
}

var OnChar = function OnChar(_ref10) {
  var children = _ref10.children;
  return React.createElement(React.Fragment, null, children);
};

function isOnCharElement(element) {
  return element.type === OnChar;
} // Should return onChars from
// every just played member that is a windup
// any first remaining that is played


function onCharsFromWindup(windup) {
  var _windup5 = _slicedToArray(windup, 3),
      _played = _windup5[0],
      remaining = _windup5[1],
      metadata = _windup5[2];

  var lastPlayed = lastPlayedMember(windup);

  var _remaining6 = _slicedToArray(remaining, 1),
      firstRemaining = _remaining6[0];

  var onChars = [];

  if (lastPlayed && memberIsWindup(lastPlayed)) {
    onChars.push.apply(onChars, _toConsumableArray(onCharsFromWindup(lastPlayed)));
  }

  if (firstRemaining && memberIsWindup(firstRemaining) && !isUnplayed(firstRemaining)) {
    onChars.push.apply(onChars, _toConsumableArray(onCharsFromWindup(firstRemaining)));
  }

  if (metadata.onChar) {
    onChars.push(metadata.onChar);
  }

  return onChars;
}

function initWindupState(windup) {
  return {
    windup: windup,
    didFinishOnce: false
  };
}

function windupReducer(state, action) {
  switch (action.type) {
    case "replace":
      return initWindupState(action.windup);

    case "next":
      return _objectSpread(_objectSpread({}, state), {}, {
        windup: next(state.windup)
      });

    case "rewind":
      return {
        windup: rewind(state.windup),
        didFinishOnce: false
      };

    case "fast-forward":
      return _objectSpread(_objectSpread({}, state), {}, {
        windup: fastForward(state.windup)
      });

    case "finish":
      return _objectSpread(_objectSpread({}, state), {}, {
        didFinishOnce: true
      });

    default:
      return state;
  }
}

function useWindup(windupInit, options) {
  var _useReducer = useReducer(windupReducer, windupInit, initWindupState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      windup = _useReducer2$.windup,
      didFinishOnce = _useReducer2$.didFinishOnce,
      dispatch = _useReducer2[1];

  var timeoutRef = useRef(null);
  var windupIsFinished = isFinished(windup);
  var skip = useCallback(function () {
    if (!windupIsFinished) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      dispatch({
        type: "fast-forward"
      });
    }
  }, [windupIsFinished]);
  var rewind = useCallback(function () {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    dispatch({
      type: "rewind"
    });
  }, []); // If windup arg changes, we should reset

  useEffect(function () {
    dispatch({
      type: "replace",
      windup: windupInit
    });
  }, [windupInit]); // If skipped is changes to true, we should skip
  // And if it's changed to false, we should restart

  useEffect(function () {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (options.skipped) {
      dispatch({
        type: "fast-forward"
      });
    }

    if (options.skipped === false) {
      dispatch({
        type: "rewind"
      });
    }
  }, [options.skipped]); // When the windup changes, onChar should fire

  useEffect(function () {
    var onChars = onCharsFromWindup(windup);
    var lastEl = lastPlayedElement(windup);

    if (onChars.length > 0 && lastEl) {
      onChars.forEach(function (onChar) {
        onChar(lastEl);
      });
    }
  }, [windup]); // If windup finishes, the onFinished should fire

  useEffect(function () {
    // Put this in a new context so that the windup finishes visually before firing this
    if (didFinishOnce === false && windupIsFinished) {
      var timeout = setTimeout(function () {
        if (options.onFinished) {
          options.onFinished();
        }

        dispatch({
          type: "finish"
        });
      }, 0);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [didFinishOnce, windupIsFinished, options]); // the windup effect itself

  useEffect(function () {
    if (!windupIsFinished) {
      var getPace = paceFromWindup(windup) || defaultGetPace;
      var lastEl = lastPlayedElement(windup);
      var nextEl = nextElement(windup);
      timeoutRef.current = setTimeout(function () {
        dispatch({
          type: "next"
        });
      }, lastEl ? getPace(lastEl, nextEl) : 0);
      return function () {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [windup, windupIsFinished]);
  return {
    windup: windup,
    skip: skip,
    rewind: rewind,
    isFinished: windupIsFinished
  };
}

function renderStringWindup(windup) {
  var played = isPlayedWindup(windup) ? windup[0] : playedElements(windup);
  var inner = played.reduce(function (acc, playedEl) {
    if (typeof playedEl === "string") {
      return acc + playedEl;
    }

    return acc + renderStringWindup(playedEl);
  }, "");
  return inner;
}

var VOID_TAGS = ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"];

function renderChildrenWindup(windup) {
  var metadata = isPlayedWindup(windup) ? windup[1] : windup[2];
  var played = isPlayedWindup(windup) ? windup[0] : playedElements(windup);
  var Outer = metadata.element || React.Fragment;

  if (metadata.props && Object.keys(metadata.props).includes("children")) {
    return React.createElement(Outer, Object.assign({}, metadata.props));
  }

  var inner = played.reduce(function (acc, playedEl) {
    if (typeof playedEl === "string") {
      var accButLast = acc.slice(0, acc.length - 1);
      var last = acc[acc.length - 1];
      return last && typeof last === "string" ? [].concat(_toConsumableArray(accButLast), [last + playedEl]) : [].concat(_toConsumableArray(acc), [playedEl]);
    }

    return [].concat(_toConsumableArray(acc), [renderChildrenWindup(playedEl)]);
  }, []);

  if (typeof metadata.element === "string" && VOID_TAGS.includes(metadata.element)) {
    return React.createElement(Outer, Object.assign({
      key: metadata.key
    }, metadata.props));
  }

  return React.createElement(Outer, Object.assign({
    key: metadata.key
  }, metadata.props), inner);
}

function useWindupString(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var windupInit = useMemo(function () {
    return windupFromString(text, options);
  }, [text]);

  var _useWindup = useWindup(windupInit, options),
      windup = _useWindup.windup,
      skip = _useWindup.skip,
      rewind = _useWindup.rewind,
      isFinished = _useWindup.isFinished;

  var rendered = renderStringWindup(windup);
  useDebugValue(rendered);
  return [rendered, {
    skip: skip,
    rewind: rewind,
    isFinished: isFinished
  }];
}

var Pause = function Pause(_ref11) {
  _objectDestructuringEmpty(_ref11);

  return null;
};

function isPauseElement(element) {
  return element.type === Pause;
}

var WindupContext = React.createContext({
  skip: function skip() {
    console.warn("Tried to use the useSkip hook outside of a WindupChildren component!!");
  },
  rewind: function rewind() {
    console.warn("Tried to use the useRewind hook outside of a WindupChildren component!");
  },
  isFinished: false
});

function useSkip() {
  var _useContext = useContext(WindupContext),
      skip = _useContext.skip;

  return skip;
}

function useRewind() {
  var _useContext2 = useContext(WindupContext),
      rewind = _useContext2.rewind;

  return rewind;
}

function useIsFinished() {
  var _useContext3 = useContext(WindupContext),
      isFinished = _useContext3.isFinished;

  return isFinished;
}

function reduceWindupArgs(prevArgs, children) {
  if (typeof children === "string") {
    return [].concat(_toConsumableArray(prevArgs), _toConsumableArray(children.split("")));
  }

  if (typeof children === "number") {
    return [].concat(_toConsumableArray(prevArgs), _toConsumableArray(children.toString().split("")));
  }

  if (!React.isValidElement(children)) {
    return prevArgs;
  }

  var _children$props = children.props,
      childrenChildren = _children$props.children,
      restProps = _objectWithoutProperties(_children$props, ["children"]);

  var paceMetaData = isPaceElement(children) ? {
    pace: function pace(char) {
      if (isMsProp(children.props)) {
        return children.props.ms;
      }

      return children.props.getPace(char);
    }
  } : {};
  var onCharMetaData = isOnCharElement(children) ? {
    onChar: children.props.fn
  } : {};
  var keyProp = children.key ? {
    key: children.key
  } : {};

  if (isPauseElement(children)) {
    return [].concat(_toConsumableArray(prevArgs), [windupFromString(" ", _objectSpread(_objectSpread({
      element: React.Fragment
    }, keyProp), {}, {
      props: {},
      pace: function pace() {
        return children.props.ms;
      }
    }))]);
  }

  if (childrenChildren === undefined) {
    return [].concat(_toConsumableArray(prevArgs), [windupFromString(" ", _objectSpread(_objectSpread(_objectSpread({
      element: children.type,
      props: restProps
    }, keyProp), paceMetaData), onCharMetaData))]);
  }

  if (typeof childrenChildren === "string") {
    return [].concat(_toConsumableArray(prevArgs), [windupFromString(childrenChildren, _objectSpread(_objectSpread(_objectSpread({
      element: children.type,
      props: restProps
    }, keyProp), paceMetaData), onCharMetaData))]);
  }

  if (childrenChildren instanceof Function) {
    return [].concat(_toConsumableArray(prevArgs), [windupFromString(" ", _objectSpread(_objectSpread(_objectSpread({
      element: children.type,
      props: _objectSpread({
        children: childrenChildren
      }, restProps)
    }, keyProp), paceMetaData), onCharMetaData))]);
  }

  var newArgs = React.Children.toArray(childrenChildren).reduce(reduceWindupArgs, []);
  var argsWithMetadata = newArgs.map(function (member) {
    if (memberIsWindup(member)) {
      var _member2 = _slicedToArray(member, 3),
          played = _member2[0],
          remaining = _member2[1],
          metadata = _member2[2];

      return [played, remaining, _objectSpread(_objectSpread(_objectSpread({}, paceMetaData), onCharMetaData), metadata)];
    }

    return member;
  });
  return [].concat(_toConsumableArray(prevArgs), [newWindup(argsWithMetadata, _objectSpread(_objectSpread(_objectSpread({
    element: children.type,
    props: restProps
  }, keyProp), paceMetaData), onCharMetaData))]);
}

function buildKeyString(children) {
  if (children === null || children === undefined) {
    return "";
  }

  return React.Children.map(children, function (child) {
    if (typeof child === "string") {
      return child;
    }

    if (typeof child === "number") {
      return child.toString();
    }

    if (React.isValidElement(child)) {
      return "#".concat(child.key || "", "<").concat(buildKeyString(child.props.children), ">");
    }

    return "";
  }).join(",");
}

function useChildrenMemo(factory, children) {
  var memoChildren = useMemo(factory, [buildKeyString(children)]);
  return memoChildren;
}

var WindupChildren = function WindupChildren(_ref12) {
  var children = _ref12.children,
      onFinished = _ref12.onFinished,
      skipped = _ref12.skipped;
  var windupInit = useChildrenMemo(function () {
    return newWindup(React.Children.toArray(children).reduce(reduceWindupArgs, []), {
      element: undefined
    });
  }, children);

  var _useWindup2 = useWindup(windupInit, {
    onFinished: onFinished,
    skipped: skipped
  }),
      windup = _useWindup2.windup,
      skip = _useWindup2.skip,
      rewind = _useWindup2.rewind,
      isFinished = _useWindup2.isFinished;

  return React.createElement(WindupContext.Provider, {
    value: {
      skip: skip,
      rewind: rewind,
      isFinished: isFinished
    }
  }, renderChildrenWindup(windup));
};

function wrapChildren(children, Wrapper) {
  if (typeof children === "string") {
    return children.split("").map(function (char, i) {
      return char === "\n" ? char : React.createElement(Wrapper, {
        key: "".concat(char, "-").concat(i)
      }, char);
    });
  }

  if (typeof children === "number") {
    return children.toString().split("").map(function (char) {
      return React.createElement(Wrapper, null, char);
    });
  }

  if (!React.isValidElement(children)) {
    return React.createElement(React.Fragment, null);
  }

  if (children.props.children) {
    var Outer = children.type;

    if (children.props.children instanceof Function) {
      return React.createElement(Outer, Object.assign({
        key: children.key
      }, children.props));
    }

    return React.createElement(Outer, Object.assign({
      key: children.key
    }, children.props), React.Children.map(children.props.children, function (ch) {
      return wrapChildren(ch, Wrapper);
    }));
  }

  return children;
}

var CharWrapper = function CharWrapper(_ref13) {
  var children = _ref13.children,
      element = _ref13.element;
  return React.createElement(React.Fragment, null, React.Children.map(children, function (ch) {
    return wrapChildren(ch, element);
  }));
};

function makeGetDescriptorsOfChildren(defaultFontStyle) {
  return function (descriptors, children) {
    if (typeof children === "string") {
      return [].concat(_toConsumableArray(descriptors), [{
        text: children,
        font: defaultFontStyle
      }]);
    }

    if (typeof children === "number") {
      return [].concat(_toConsumableArray(descriptors), [{
        text: children.toString(),
        font: defaultFontStyle
      }]);
    }

    if (!React.isValidElement(children)) {
      return descriptors;
    }

    if (isStyledTextElement(children) && typeof children.props.children === "string") {
      return [].concat(_toConsumableArray(descriptors), [{
        text: children.props.children,
        font: children.props.fontStyle
      }]);
    }

    if (isStyledTextElement(children)) {
      return [].concat(_toConsumableArray(descriptors), _toConsumableArray(React.Children.toArray(children.props.children).reduce(makeGetDescriptorsOfChildren(children.props.fontStyle), [])));
    }

    return [].concat(_toConsumableArray(descriptors), _toConsumableArray(React.Children.toArray(children.props.children).reduce(makeGetDescriptorsOfChildren(defaultFontStyle), [])));
  };
}

function reinsertStringsIntoChildren(_ref14, children) {
  var _ref15 = _slicedToArray(_ref14, 2),
      accChildren = _ref15[0],
      accStrings = _ref15[1];

  if (typeof children === "string" || typeof children === "number") {
    var _accStrings = _toArray(accStrings),
        firstString = _accStrings[0],
        restStrings = _accStrings.slice(1);

    return [[].concat(_toConsumableArray(accChildren), [firstString]), restStrings];
  }

  if (!React.isValidElement(children)) {
    return [accChildren, accStrings];
  }

  var _React$Children$toArr = React.Children.toArray(children.props.children).reduce(reinsertStringsIntoChildren, [[], accStrings]),
      _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 2),
      subChildrenAcc = _React$Children$toArr2[0],
      subStringsAcc = _React$Children$toArr2[1];

  return [[].concat(_toConsumableArray(accChildren), [React.cloneElement(children, {
    children: subChildrenAcc
  })]), subStringsAcc];
}

function isStyledTextElement(element) {
  return element.type === StyledText;
}

function StyledText(_ref16) {
  var children = _ref16.children;
  return React.createElement(React.Fragment, null, children);
}

var Linebreaker = function Linebreaker(_ref17) {
  var children = _ref17.children,
      fontStyle = _ref17.fontStyle,
      width = _ref17.width;
  // CAVEATS:
  // fontStyle must match the font style of the characters inside
  // non-character elements must not add width to the line.
  // must be used OUTSIDE of WindupChildren component
  var childrenArray = React.Children.toArray(children);
  var descriptors = childrenArray.reduce(makeGetDescriptorsOfChildren(fontStyle), []);
  var transformedStrings = breakLines(descriptors, width, fontStyle);

  var _childrenArray$reduce = childrenArray.reduce(reinsertStringsIntoChildren, [[], transformedStrings]),
      _childrenArray$reduce2 = _slicedToArray(_childrenArray$reduce, 1),
      transformedChildren = _childrenArray$reduce2[0];

  return React.createElement("div", {
    style: {
      whiteSpace: "pre"
    }
  }, transformedChildren);
};

var Effect = function Effect(_ref18) {
  var fn = _ref18.fn;
  useEffect(function () {
    fn();
  }, []);
  return null;
};

function textFromChildren(children) {
  return React.Children.map(children, function (ch) {
    if (typeof ch === "string") {
      return ch;
    }

    if (typeof ch === "number") {
      return ch.toString();
    }

    if (!isValidElement(ch)) {
      return "";
    }

    if (ch.props.children) {
      return textFromChildren(ch.props.children);
    }

    return "";
  }).join("");
}

export { CharWrapper, Effect, Linebreaker, OnChar, Pace, Pause, WindupChildren, defaultGetPace, textFromChildren, useIsFinished, useRewind, useSkip, useWindupString };